import {axiosInstance} from "../helpers/axios";

const userAgent = window.navigator.userAgent;

const changePasswordRequest = (email) => {
    return axiosInstance.post("change_password_request/", {
        "username": email
    })
    .then((res) => {
        const data = res.data;
        /*if(data.Codigo === 0) {
            data.correo = user;
            sessionStorage.setItem("user", JSON.stringify(data));
            UpdateSecurityKey(data.llaveSeguridad);
        }*/
        return data;
    })
    .catch(err => {
        console.log("error");
        //console.log(err.message);
        return "ERROR_SERVICIO";
    })
}


const changePassword = (email, passTem, newPass, newPassConf) => {
    return axiosInstance.post("change_password/", {
        "username": email,
        "temporaryPassword": passTem,
        "newPassword": newPass,
        "newPasswordConfirmation": newPassConf
    })
    .then((res) => {
        const data = res.data;
        /*if(data.Codigo === 0) {
            data.correo = user;
            sessionStorage.setItem("user", JSON.stringify(data));
            UpdateSecurityKey(data.llaveSeguridad);
        }*/
        return data;
    })
    .catch(err => {
        console.log("error");
        //console.log(err.message);
        return "ERROR_SERVICIO";
    })
}

export default { changePasswordRequest, changePassword };
